'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.geocode = exports.locationSearch = exports.locationsByMsa = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _querystring = require('querystring');

var _sagaTools = require('@classpass/saga-tools');

var _universalFetch = require('../../../universal-fetch');

var _universalFetch2 = _interopRequireDefault(_universalFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationsByMsa = exports.locationsByMsa = (0, _sagaTools.makeEntityScaffold)('SAGA.API.LOCATIONS_BY_MSA', function (client, msaId) {
  return client.locations.getListV2(msaId).then(function (data) {
    return data.locations;
  });
});

var locationSearch = exports.locationSearch = (0, _sagaTools.makeEntityScaffold)('SAGA.GAPI.PLACES_AUTOCOMPLETE', function (query, options) {
  return (0, _universalFetch2.default)('/_location/search?' + (0, _querystring.stringify)((0, _extends3.default)({
    input: query
  }, options)), { credentials: 'same-origin' }).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data.predictions;
  });
});

var geocode = exports.geocode = (0, _sagaTools.makeEntityScaffold)('SAGA.GAPI.GEOCODE', function (params) {
  return (0, _universalFetch2.default)('/_location/geocode?' + (0, _querystring.stringify)(params), { credentials: 'same-origin' }).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data.results && data.results[0];
  });
});